import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import GroupsManager from "@/components/GroupsManager";
import { ArrowLeft } from "@phosphor-icons/react";

export default function LeagueGroups() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    api.get(`/leagues/${id}`).then(({ data }) => setEvent(data)).catch(() => {});
  }, [id]);

  return (
    <div className="space-y-4" data-testid="league-groups-page">
      <Link to={`/dashboard/ligas`} className="inline-flex items-center text-gray-400 hover:text-[#CCFF00] text-sm">
        <ArrowLeft size={16} className="mr-1" /> Volver a Ligas
      </Link>
      <GroupsManager
        eventKind="league"
        eventId={id}
        eventName={event?.name || "Liga"}
        category={event?.category || ""}
      />
    </div>
  );
}
